import axios from 'axios';
import managerApi from './axiosConfig';

// The employee portal signs in with employee_access_token; the manager app uses access_token (axiosConfig).
// Shared components such as DocumentUpload are used from both, so they send whichever login is active here.
const portalApi = axios.create({ baseURL: '/api' });
portalApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('employee_access_token');
  if (token) config.headers['Authorization'] = `Bearer ${token}`;
  return config;
});
portalApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('employee_access_token');
      localStorage.removeItem('employee_refresh_token');
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

// The portal lives under /employeeportal. Going by the page, not by whether a portal token happens to be
// stored, means a manager who has also used the portal in the same browser still sends the manager login.
const inPortal = () => window.location.pathname.toLowerCase().startsWith('/employeeportal');
const client = () => (inPortal() ? portalApi : managerApi);

const smartApi = {
  get: (...args) => client().get(...args),
  post: (...args) => client().post(...args),
  delete: (...args) => client().delete(...args),
};

export default smartApi;
